import React from "react";
import useRouter from "../../../../../../hooks/use-router";
import {Col, Row} from "reactstrap";
import classnames from "classnames";
import TryAgain from "../../../../../../components/app-specific/try-again";
import OutlinedButton from "../../../../../../components/base/button/outlined-button";
import {routeFunctions} from "../../../../../../routes";


const TicketDefinitionServices = ({services, fetchAgain, loading}) => {
    const {params: {application}, history} = useRouter();

    /**
     * Navigates the user to the ticket type selection for the selected service of ticket-definition
     * @param service {any}
     */
    const navigateToNextSection = (service) => {
        history.push(routeFunctions.private.withApplication.newTicket.ticketDefinition(application, service.id))
    }


    return (
        <>
            <Row className={classnames('ticket-definition', {'loading-div': loading})}>
                <Col xs={12} className={'mb-4'}>
                    <p className={'title'}>
                        Select Your Service
                    </p>
                </Col>
                <Col xs={12}>
                    {
                        loading
                            ? <>
                                {Array(4).fill(null).map((e, index) => (
                                    <div className={'button my-2'} key={index}>
                                        <div/>
                                    </div>
                                ))}
                            </>
                            : !services?.length
                                ? <TryAgain onClick={fetchAgain}
                                            text={'There is no service available for your application. Please contact our' +
                                                ' technical support for more information'}
                                            buttonText={'Load Services Again'}/>
                                : services?.map((service) => (
                                    <OutlinedButton
                                        key={service.id}
                                        className={'button'}
                                        onClick={() => navigateToNextSection(service)}
                                    >
                                        {service?.title ?? ''}
                                    </OutlinedButton>
                                ))
                    }
                </Col>
            </Row>
        </>
    );
}

export default TicketDefinitionServices;
